import warehouse from '../en/warehouse'

const cnWarehouse = {}

for (const cn in warehouse) {
  cnWarehouse[cn] = cn
}

export default cnWarehouse
